export default __webpack_public_path__ + "static/poster-e73354c4f3f975c30775246079522666.png";